import { render, staticRenderFns } from "./UserImage.vue?vue&type=template&id=2fb33b9e&"
import script from "./UserImage.vue?vue&type=script&lang=js&"
export * from "./UserImage.vue?vue&type=script&lang=js&"
import style0 from "./UserImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserImage.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/UserImage.vue
// module id = 302
// module chunks = 1